<template lang="pug">
v-card
  v-card-title
    v-text-field(v-model='search' append-icon='search' label='Search' single-line='' hide-details='')

  v-data-table.elevation-1(v-model='masiveUsers' :headers='headers' :items='users' :show-select='masiveAssign' :search="search")
    template(v-slot:top)
      v-toolbar(flat='' color='white')
        v-toolbar-title Usuarios
        v-divider.mx-4(inset='' vertical='')
        .flex-grow-1
        .masive-assign
          v-switch(v-model='masiveAssign' :label='`Asignación Masiva`')
        v-btn.mb-2.massive-btn(v-if='masiveAssign' color='secondary' dark='' @click='checkExamsMassive()') Asignar Examenes
        v-btn.mb-2(color='primary' dark='' @click='newUser()') Nuevo Usuario
        v-dialog(v-model='dialog_exams')
          v-card
            v-card-title
              span.headline Asignar Examenes
            v-card-text
              v-container
                v-row
                  v-col(cols='12' sm='5' md='5' style='margin-right:2.5rem;') 
                    template(v-if='masiveAssign')
                      v-row
                          v-text-field(v-model='masiveUsers.length' label='Numero de Usuarios' disabled)
                    template(v-else)
                      v-row
                        v-text-field(v-model='editedItem.name' label='Nombre' disabled)
                  v-col(cols='12' sm='5' md='5')
                    v-row
                      v-data-table.elevation-1(v-model='selectedExams' :headers='examsHeaders' :items='exams' :single-select='singleSelect' item-key='id' show-select='')

            v-card-actions
              .flex-grow-1
              v-btn(color='blue darken-1' text='' @click='close') Cancelar
              v-btn(color='blue darken-1' text='' @click='assignExams') Guardar
        v-dialog(v-model='dialog_groups')
          v-card
            v-card-title
              span.headline Asignar Grupos
            v-card-text
              v-container
                v-row
                  v-col(cols='12' sm='5' md='5' style='margin-right:2.5rem;') 
                    template(v-if='masiveAssignGroups')
                      v-row
                          v-text-field(v-model='masiveUsers.length' label='Numero de Usuarios' disabled)
                    template(v-else)
                      v-row
                        v-text-field(v-model='editedItem.name' label='Nombre' disabled)
                  v-col(cols='12' sm='5' md='5')
                    v-row
                      v-data-table.elevation-1(v-model='selectedGroups' :headers='groupsHeaders' :items='groups' :single-select='singleSelect' item-key='id' show-select='')

            v-card-actions
              .flex-grow-1
              v-btn(color='blue darken-1' text='' @click='close') Cancelar
              v-btn(color='blue darken-1' text='' @click='assignGroups') Guardar
        v-dialog(v-model='change_pass')
          v-card
            v-card-title
              span.headline Modificar Password
            v-card-text
              v-container
                v-row
                  v-col(cols='12' sm='5' md='5' style='margin-right:2.5rem;') 
                    v-row
                      v-text-field(v-model='editedItem.name' label='Nombre' disabled)
                  v-col(cols='12' sm='5' md='5' style='margin-right:2.5rem;') 
                    v-row
                      v-text-field(v-model='new_pass' label='New Password' type='password')
                 

            v-card-actions
              .flex-grow-1
              v-btn(color='blue darken-1' text='' @click='change_pass = false') Cancelar
              v-btn(color='blue darken-1' text='' @click='changePass') Guardar
    
    template(v-slot:item.active='{ item }') 
      v-icon(v-if='item.active' small='' color='green' style='cursor:pointer' @click='activateUser(item.id,false)')
        | account_circle
      v-icon(v-else small='' color='red' style='cursor:pointer' @click='activateUser(item.id,true)')
        | account_circle

    template(v-slot:item.action='{ item }')
      v-icon.mr-4(v-if='item.type == "Profesor"' small='' @click='checkGroups(item)' alt='Asignar Grupos')
        | group_add
      v-icon.mr-4(small='' @click='checkExams(item)' alt='Asignar Examenes')
        | assignment
      v-icon.mr-4(small='' @click='checkForPass(item)' alt='Modificar Password')
        | lock
    template(v-slot:no-data='')
      v-btn(color='primary' @click='initialize') Reset

</template> 

<script>

  import { config } from '../config.js'

  export default {
    data: () => ({
      dialog: false,
      search:'',
      dialog_exams: false,
      dialog_groups: false,
      loading: false,
      singleSelect: false,
      change_pass: false,
      masiveAssign: false,
      masiveAssignGroups: false,
      new_pass:'',
      masiveUsers: [],
      selectedExams: [],
      selectedGroups: [],
      exams: [],
      groups: [],
      headers: [
        { text: 'Id', value: 'id', sortable: false },
        { text: 'Usuario', value: 'name', sortable: true },
        { text: 'Activo', value: 'active', sortable: true },
        { text: 'Expiración', value: 'expiration', sortable: true },
        { text: 'Última conexión', value: 'lastConnection', sortable: true },
        { text: 'Tipo de Usuario', value: 'type', sortable: true },
        { text: 'Acciones', value: 'action', sortable: false }
      ],
      examsHeaders: [
        {
          text: 'Nombre del Examen',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Descripción', value: 'desc', sortable: false }
      ],
      groupsHeaders: [
        {
          text: 'Grupo',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        { text: 'Descripción', value: 'desc', sortable: false },
        { text: 'Acciones', value: 'action', sortable: false }
      ],
      users: [],
      editedIndex: -1,
      editedItem: {
        id: '',
        name: '',
        active: '',
        expiration: '',
        lastConnection:'',
        exams:'',
        updateDate: ''
      },
      defaultItem: {
        id: '',
        name: '',
        active: '',
        expiration: '',
        lastConnection:'',
        exams:'',
        updateDate: ''
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo registro' : 'Editar registro'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.$emit("loadingEvent", true);
      this.initialize()
    },

    methods: {
      newUser(){
        this.$router.push({ name: 'manageUsers' });
      },
      initialize () {
        this.axios.get(`${config.serviceUri}users`)
        .then( (response) => {
            console.log('Succes request: ',response.data);
            this.users = response.data.payload;
        })
        .catch( (error) => {
            console.log('Error: ', error);
            this.$emit("loadingEvent", false);
        });

        this.axios.get(`${config.serviceUri}catalogs?catalog=groups`)
        .then( (response) => {
            console.log('Succes request: ',response.data);
            this.groups = response.data.payload.sort(function (a, b) {
                            if (a.name > b.name) {
                              return 1;
                            }
                            if (a.name < b.name) {
                              return -1;
                            }
                            return 0;
                          });
            this.$emit("loadingEvent", false);
        })
        .catch( (error) => {
            console.log('Error: ', error);
            this.$emit("loadingEvent", false);
        });

        this.axios.get(`${config.serviceUri}exams`)
        .then( (response) => {
            console.log('Succes request: ',response.data);
            this.exams = response.data.payload;
            this.$emit("loadingEvent", false);
        })
        .catch( (error) => {
            console.log('Error: ', error);
        });

      },
      changePass(){
        this.$emit("loadingEvent", true);
        let user = {};
        user.user = this.editedItem;
        user.user_key = this.new_pass;
        
        if(user.user.id){
          this.axios.patch(`${config.serviceUri}users?id=${user.user.id}`, user)
            .then( (response) => {
                console.log('Succes Password Change: ',response.data);                
                this.$emit("loadingEvent", false);
            })
            .catch( (error) => {
                console.log('Error: ', error);
                let msg_global_txt = 'Ocurrio un problem al modificar tu usario intentalo mas tarde o contacta con el administrador';
                this.$emit("loadingEvent", false);
            });
        }else{
          console.error('Error: No existe dicho usuario');
          this.$emit("loadingEvent", false);
        }
      },
      checkForPass(item){
        this.editedIndex = this.users.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.change_pass = true;
      },
      checkExamsMassive(){
        this.selectedExams = [];
        this.dialog_exams = true;
      },
      checkGroups(item){
        this.$emit("loadingEvent", true);
        this.selectedGroups = [];
        this.editedIndex = this.users.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.selectedGroups = this.editedItem.asoc_groups ? this.editedItem.asoc_groups : [];
        
        this.dialog_groups = true;

      },
      checkExams(item){
        this.$emit("loadingEvent", true);
        this.selectedExams = [];
        this.editedIndex = this.users.indexOf(item);
        this.editedItem = Object.assign({}, item);

        this.axios.get(`${config.serviceUri}exams?idRelated=${item.id}`)
        .then( (response) => {
            console.log('Succes request: ',response.data);
            let auth_response = response.data.payload;
            let auth_exams = auth_response.exams;

            auth_exams.forEach( ex_id => {
              this.selectedExams.push(this.exams.filter( e => e.id == ex_id)[0]);
            })

            this.editedItem.id_authExam = auth_response.id;

            this.$emit("loadingEvent", false);
        })
        .catch( (error) => {
            console.log('Error: ', error);
            this.$emit("loadingEvent", false);
        });

        this.dialog_exams = true;
      },
      
      editItem (item) {
        this.editedIndex = this.users.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.users.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.users.splice(index, 1)
      },

      close () {
        this.dialog = false
        this.dialog_exams = false
        this.dialog_groups = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)

        this.$emit("loadingEvent", false);
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.categories[this.editedIndex], this.editedItem)
        } else {
          console.log('New item');

          let catalog =  {
              name: 'categories',
              data: this.editedItem
          }

          this.axios.post(`${config.serviceUri}catalogs`, catalog )
            .then( (response) => {
                console.log('Succes Creted: ',response.data);
                this.categories.push(catalog.data)
                this.loading = false;
            })
            .catch( (error) => {
                console.log('Error: ', error);
                this.loading = false;
            });
        }
        this.close()
      },

      assignGroups(){
        console.log('User for asociate groups asign', this.editedItem )
        let _this = this;
        
        this.axios.patch(`${config.serviceUri}users?id=${this.editedItem.id}&assign=${true}`, {
          asoc_groups: _this.selectedGroups ? _this.selectedGroups : [] 
        })
        .then( (response) => {
            console.log('Succes groups assign: ',response.data);
            this.$emit("loadingEvent", false);
            this.dialog_groups = false;
        })
        .catch( (error) => {
            console.log('Error: ', error);
            this.$emit("loadingEvent", false);
        });
      },

      assignExams(){
        this.$emit("loadingEvent", true);
        let auth_exams = this.selectedExams.map( e => e.id );

        if(this.masiveAssign){
          if(this.masiveUsers && this.masiveUsers.length > 0){
            this.masiveUsers.forEach( u => {
              let new_auth = {};
              new_auth = {
                id_user: u.id,
                exams: auth_exams
              }

              this.axios.post(`${config.serviceUri}exams?assign=auth`, new_auth )
                .then( (response) => {
                    console.log('Succes Realted Exam Created: ', response.data);
                })
                .catch( (error) => {
                    console.log('Error: ', error);
                    this.$emit("loadingEvent", false);
                });

            })
            this.dialog_exams = false;
            this.$emit("loadingEvent", false);
          }
        }else{
          console.log('User for exam asign', this.editedItem )

          let new_auth = {
            id_user: this.editedItem.id,
            exams: auth_exams
          }

          this.axios.post(`${config.serviceUri}exams?assign=auth`, new_auth )
            .then( (response) => {
                console.log('Succes Realted Exam Created: ',response.data);
                this.dialog_exams = false;
                this.$emit("loadingEvent", false);
            })
            .catch( (error) => {
                console.log('Error: ', error);
                this.dialog_exams = false;
                this.$emit("loadingEvent", false);
            });
        }

      },

      activateUser(id, active){
        this.$emit("loadingEvent", true);
        this.axios.patch(`${config.serviceUri}users?id=${id}&service=activate&status=${active}` )
          .then( (response) => {
              console.log('Succes Realted Exam Created: ',response.data);
              this.exams.push(response.data)
              this.$emit("loadingEvent", false);
          })
          .catch( (error) => {
              console.log('Error: ', error);
              this.$emit("loadingEvent", false);
          });
      }
    },
  }
</script>

<style scoped>
.masive-assign{
  margin: .75% 10px auto !important;
}

.massive-btn{
  margin: 0 10px;
}
</style>
